"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEnrollmentConfirmed = exports.isEnrollableLoyaltyBehavior = void 0;
const isEnrollableLoyaltyBehavior = (behavior) => typeof behavior.enrollCustomer === 'function';
exports.isEnrollableLoyaltyBehavior = isEnrollableLoyaltyBehavior;
/**
 * True only when enrollment was positively confirmed. A missing result — the read
 * never happened — is not a confirmation.
 */
const isEnrollmentConfirmed = (result) => (result === null || result === void 0 ? void 0 : result.status) === 'enrolled';
exports.isEnrollmentConfirmed = isEnrollmentConfirmed;
//# sourceMappingURL=types.js.map